<template>
    <section>
        <div class="banGongCard">
            <div id="print" ref="printContent">
                <el-table :data="deviceinfoData" id="table" :show-header="false" size="mini" border
                    :span-method="arraySpanMethod" :row-style="{ height: '20px' }" :cell-style="tableCellStyle"
                    style="font-size:10px;">
                    <el-table-column prop="prop1" :width="90" align="center"></el-table-column>
                    <el-table-column prop="prop2" :width="120"></el-table-column>
                    <el-table-column prop="prop3" :width="60">
                        <template slot-scope="scop">
                            <img :src="scop.row.prop3" style="width: 110px;height: 110px;margin-top: 5px;"
                                v-if="scop.row.prop3 != '使用人' && scop.row.prop3 != '规格型号'">
                            <span v-else>{{ scop.row.prop3 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="prop4" :width="120"></el-table-column>
                </el-table>


            </div>
            <div style="margin-top:10px">
                <el-button type="primary" v-print="printObj">打印</el-button>

            </div>
        </div>
    </section>
</template>
<script>
export default {
    data() {
        return {
            printObj: {
                id: 'print',//id
                popTitle: "设备管理卡片",//自定义设置标题
                style: "margin-top:20px"
            },
            qrcodeUrl: "https://deviceinfomanagement.oss-cn-beijing.aliyuncs.com/qrcodeImage/2023-02-25-9-13-2.png",
            deviceinfoData: []
        }
    },
    props: ['deviceinfo'],
    methods: {
        // print(){
        //     this.$print(this.$refs.print) 
        // }el-table_7_column_30
        // 单元格样式
        tableCellStyle({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color:#b7e0ff;padding:0px;border-color: #000000;border-top:#000000; '
            }

            if (rowIndex === 3) {
                return 'padding:0px;border-color: #000000;border-top:#000000'
            }
            return 'border-color: #000000;padding:1px;border-left:#000000'
        },
        // 合并单元格
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                if (columnIndex === 0) {
                    return {
                        rowspan: 1,
                        colspan: 4
                    };
                    // return [1, 4];
                }
                else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
            }
            if (rowIndex === 1) {
                if (columnIndex === 1) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    };
                }
                // else if (columnIndex != 1 && columnIndex != 0) {
                //     return {
                //         rowspan: 0,
                //         colspan: 0,
                //     };
                // }
            }
            if (rowIndex === 2 || rowIndex === 3 || rowIndex === 4 || rowIndex === 5 || rowIndex === 6) {
                if (columnIndex === 1) {
                    return {
                        rowspan: 1,
                        colspan: 2
                    };
                }
                else if (columnIndex != 0 && columnIndex != 2) {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }

            }
            if (columnIndex === 2) {
                if (rowIndex === 2) {
                    return {
                        rowspan: 5,
                        colspan: 1
                    };
                }
                else if (rowIndex != 7 && rowIndex != 1) {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
            }

        },
        setTableData() {
            debugger
            this.deviceinfoData = []
            this.deviceinfoData.push({
                prop1: "办公设备管理卡片"
            }, {
                prop1: "资产名称",
                prop2: "",
                prop3: "规格型号",
                prop4: ""
            }, {
                prop1: "资产编码",
                prop2: "",
                prop3: "",
            }, {
                prop1: "技术配置",
                prop2: ""
            }, {
                prop1: "生产厂家",
                prop2: ""
            }, {
                prop1: "出厂编号",
                prop2: ""
            }, {
                prop1: "开始使用日期",
                prop2: ""
            }, {
                prop1: "使用部门/项目",
                prop2: "",
                prop3: "使用人",
                prop4: "",

            })
            this.deviceinfoData[1].prop2 = this.deviceinfo.zcmc
            this.deviceinfoData[1].prop4 = this.deviceinfo.sbxh
            this.deviceinfoData[2].prop2 = this.deviceinfo.zcbh
            this.deviceinfoData[2].prop3 = this.deviceinfo.qrcodeUrl
            this.deviceinfoData[3].prop2 = this.deviceinfo.bz
            this.deviceinfoData[4].prop2 = this.deviceinfo.sccj
            this.deviceinfoData[5].prop2 = this.deviceinfo.ccbh
            this.deviceinfoData[6].prop2 = this.deviceinfo.qyrq
            this.deviceinfoData[7].prop2 = this.deviceinfo.companyname
            this.deviceinfoData[7].prop4 = this.deviceinfo.syr
        }
    },
    created() {
        this.setTableData();
    }
}

</script>

<style lang="less" scoped>
.el-table--border {
    border-color: #000000 !important;
    width: 392px;
    border-right: 1px solid #000000 !important;
    border-bottom: 1px solid #000000 !important;
}

#table /deep/ .cell {
    padding-left: 2px !important;
    padding-right: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/market/deviceCardbg.vue